import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Container,
    Grid,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import getAxiosInstance from 'api';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import logoWhite from '../../../assets/images/logo-active.png';

const CreatePassword = () => {
  const { token } = useParams();
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    newpassword: '',
    confirmpassword: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    document.body.classList.add('authentication-bg');
    return () => document.body.classList.remove('authentication-bg');
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const errors = {};
    let isValid = true;

    if (!formData.newpassword) {
      errors.newpassword = 'Password is required';
      isValid = false;
    }

    if (!formData.confirmpassword) {
      errors.confirmpassword = 'Confirm password is required';
      isValid = false;
    } else if (formData.confirmpassword !== formData.newpassword) {
      errors.confirmpassword = 'Passwords do not match';
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);

        getAxiosInstance(
          `auth/admin/resetSecondaryAdminPassword`,
          'post',
          {
            token,
            newPassword: formData?.newpassword,
          },
          {
            'journey-type': 'Report',
          }
        )
          .then((res) => {
            if (res?.data?.codes === 200) {
              setSuccessMsg('Password successfully created!');
              setErrorMsg('');
              setLoading(false);
              setTimeout(()=>{
                navigate('/login');
              },1000)   
            }
          })
          .catch((err) => {
            setErrorMsg('Failed to create password');
          });

  };

  return (
    <Box sx={{ py: 5 }}>
      <Container maxWidth="sm">
        <Box textAlign="center" mb={3}>
          <img src={logoWhite} alt="E-DOC ONLINE" height={40} />
        </Box>

        <Card elevation={1} sx={{ borderRadius: 2 }}>
          <CardContent>
            <Typography
              variant="h3"
              textAlign="center"
              fontWeight={600}
              color="#f26c2f"
              mb={3}
            >
              Create Password
            </Typography>

            {errorMsg && <Alert severity="error">{errorMsg}</Alert>}
            {successMsg && <Alert severity="success">{successMsg}</Alert>}

            <Box component="form" onSubmit={handleSubmit} noValidate>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight={500}>
                      Password
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Password"
                      name="newpassword"
                      type="password"
                      value={formData.newpassword}
                      onChange={handleChange}
                      error={!!formErrors.newpassword}
                      helperText={formErrors.newpassword}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight={500}>
                      Confirm Password
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Confirm Password"
                      name="confirmpassword"
                      type="password"
                      value={formData.confirmpassword}
                      onChange={handleChange}
                      error={!!formErrors.confirmpassword}
                      helperText={formErrors.confirmpassword}
                      margin="normal"
                    />
                  </Grid>
                </Grid>
              </Stack>

              <Box textAlign="right" mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  color="secondary"
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={22} color="inherit" />
                  ) : (
                    'Create Password'
                  )}
                </Button>
              </Box>
            </Box>

            <Box mt={4} textAlign="center">
              <Button variant="outlined" color="secondary" type="submit" onClick={()=>{
                navigate('/login')
              }}>
                Signin
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
};

export default CreatePassword;
